import Service from "../../service";

const CommunicationService = {
    // Audience Api 
    getAudienceList: async (token, current_page, items_per_page, body = null) => {
        try {
          return await Service.post({
            url: `/accounts/communication/audience/list?current_page=${current_page}&items_per_page=${items_per_page}`,
            token,
            data: body,
          });
        } catch (error) {
          throw error;
        }
      },

    deleteAudience:async (token,id) => {
        try {
          return Service.remove({
            url: `/accounts/communication/audience?id=${id}`,
            token,
          });
        } catch (err) {
          throw err;
        }
      },
      sendFilterParams: async (data, token) => {
        try {
          return await Service.post({ url: "/accounts/communication/audience", data, token });
        } catch (error) {
          throw error;
        }
      },
      editFilter: async (data, token) => {
        try {
          return await Service.update({ url: "/accounts/communication/audience", data, token });
        } catch (error) {
          throw error;
        }
      },
      getAudienceById: async (id, token) => {
        try {
          return await Service.get(`/accounts/communication/audience?id=${id}`, token);
        } catch (error) {
          throw error;
        }
      },
      importNewsletterList: async (data, token) => {
        try {
          return await Service.post({
            url: "/accounts/communication/newsletter/import",
            data,
            token,
          });
        } catch (error) {
          throw error;
        }
      },
    // Campains Api 
    createCampaign: async (data, token) => {
      try {
        return await Service.post({ url: "/accounts/communication/campaign", data, token });
      } catch (error) {
        throw error;
      }
    },
    updateCampaign: async (data, token) => {
      try {
        return await Service.update({ url: "/accounts/communication/campaign", data, token });
      } catch (error) {
        throw error;
      }
    },
    getCampaignList: async (token, current_page, items_per_page, body = null) => {
      try {
        return await Service.post({
          url: `/accounts/communication/campaign/list?current_page=${current_page}&items_per_page=${items_per_page}`,
          token,
          data: body,
        });
      } catch (error) {
        throw error;
      }
    },
    deleteCampaign:async (token,id) => {
      try {
        return Service.remove({
          url: `/accounts/communication/campaign?id=${id}`,
          token,
        });
      } catch (err) {
        throw err;
      }
    },
    duplicateCampaign: async (token, id,body=null) => {
      try {
        return await Service.update({
          url: `/accounts/communication/campaign/duplicate?id=${id}`,
          token,
          data: body,
        });
      } catch (error) {
        throw error;
      }
    },
    pauseCampaign: async (token, id,body=null) => {
      try {
        return await Service.update({
          url: `/accounts/communication/campaign/pause?id=${id}`,
          token,
          data: body,
        });
      } catch (error) {
        throw error;
      }
    },
    startCampaign: async (token, id,body=null) => {
      try {
        return await Service.update({
          url: `/accounts/communication/campaign/start?id=${id}`,
          token,
          data: body,
        });
      } catch (error) {
        throw error;
      }
    },
    getCampaignById: async (id, token) => {
      try {
        return await Service.get(`/accounts/communication/campaign?id=${id}`, token);
      } catch (error) {
        throw error;
      }
    },
    getCampaignDetailsList: async (token, current_page, items_per_page, body = null) => {
      try {
        return await Service.post({
          url: `/accounts/communication/campaign-reach/list?current_page=${current_page}&items_per_page=${items_per_page}`,
          token,
          data: body,
        });
      } catch (error) {
        throw error;
      }
    },   
    // Templates Api 
    getTemplateList: async (token, current_page, items_per_page, body = null) => {
      try {
        return await Service.post({
          url: `/setting/v1/templates/list?current_page=${current_page}&items_per_page=${items_per_page}`,
          token,
          data: body,
        });
      } catch (error) {
        throw error;
      }
    },
    sendTemplateTestEmail: async (token,body = null) => {
      try {
        return await Service.post({
          url: `/setting/v1/templates/email`,
          token,
          data: body,
        });
      } catch (error) {
        throw error;
      }
    },
    //Automation
    createAutomation: async (data, token) => {
      try {
        return await Service.post({ url: "/accounts/communication/automation", data, token });
      } catch (error) {
        throw error;
      }
    },
    getAutomationList: async (token, current_page, items_per_page, body = null) => {
      try {
        return await Service.post({
          url: `/accounts/communication/automation/list?current_page=${current_page}&items_per_page=${items_per_page}`,
          token,
          data: body,
        });
      } catch (error) {
        throw error;
      }
    },
  
    getEventTypesList: async (token) => {
      try {
        return await Service.get( `/accounts/communication/automation/types`,token);
      } catch (error) {
        throw error;
      }
    },
    deleteAutomation:async (token,id) => {
      try {
        return Service.remove({
          url: `/accounts/communication/automation?id=${id}`,
          token,
        });
      } catch (err) {
        throw err;
      }
    },
    duplicateAutomation: async (token, id,body=null) => {
      try {
        return await Service.update({
          url: `/accounts/communication/automation/duplicate?id=${id}`,
          token,
          data: body,
        });
      } catch (error) {
        throw error;
      }
    },
    activeAutomation: async (token,body=null) => {
      try {
        return await Service.update({
          url: `/accounts/communication/automation/activate`,
          token,
          data: body,
        });
      } catch (error) {
        throw error;
      }
    },
    updateAutomation: async (data, token) => {
      try {
        return await Service.update({ url: "/accounts/communication/automation", data, token });
      } catch (error) {
        throw error;
      }
    },
}

export default CommunicationService;